import { useState } from "react";
import { Body1, Carousel, Display2, getTokenValue, ResponsiveImage, shadow, TextSpan, YStack } from "@medbillai/ui";
import { NewGLogo } from "../../components/local-images";
import { OnboardingScreen } from "../../components/OnboardingScreen";
import { type OnDone, tagged } from "../../lib/flow-engine";
export type ValuePropsOutcomes = {
  signUp: {};
  logIn: {};
  back: {};
};
const Outcome = tagged<ValuePropsOutcomes>();
const SLIDES = [{
  title: "Your trusted guide for medical bills",
  src: {
    web: "/static/onboarding/Carousel-1.png",
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-require-imports
    native: require("../../assets/onboarding/Carousel-1.png")
  },
  caption: "We analyze your bills, negotiate with providers, and save you money."
}, {
  title: "We fight the bill so you don't have to",
  src: {
    web: "/static/onboarding/Carousel-2.png",
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-require-imports
    native: require("../../assets/onboarding/Carousel-2.png")
  },
  caption: "A dedicated health advocate will work your case to maximize your savings."
}, {
  title: "No savings, no fee. Zero risk.",
  src: {
    web: "/static/onboarding/Carousel-3.png",
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-require-imports
    native: require("../../assets/onboarding/Carousel-3.png")
  },
  caption: "We only get paid when you save. No fine print, no surprises."
}] as const;
const LOGO_SIZE = Number(getTokenValue("$si5", "size"));
export function ValueProps({
  onDone
}: {
  onDone: OnDone<ValuePropsOutcomes>;
}) {
  const [_, setActiveIndex] = useState(0);
  return <OnboardingScreen showBackgroundGradient data-sentry-element="OnboardingScreen" data-sentry-component="ValueProps" data-sentry-source-file="ValueProps.tsx">
      <OnboardingScreen.Nav showLogo={false} data-sentry-element="OnboardingScreen.Nav" data-sentry-source-file="ValueProps.tsx" />
      <OnboardingScreen.Content data-sentry-element="OnboardingScreen.Content" data-sentry-source-file="ValueProps.tsx">
        <YStack paddingBottom="$sp1.5" alignItems="center" data-sentry-element="YStack" data-sentry-source-file="ValueProps.tsx">
          <NewGLogo height={LOGO_SIZE} width={LOGO_SIZE} data-sentry-element="NewGLogo" data-sentry-source-file="ValueProps.tsx" />
        </YStack>
        {/* Negative margin lets the swipe strip span past Content's $sp2.5 padding;
            each slide re-applies it internally. maxHeight caps whitespace below
            the image — tune if slide content changes. */}
        <YStack flex={1} marginHorizontal="$-sp2.5" maxHeight={520} data-sentry-element="YStack" data-sentry-source-file="ValueProps.tsx">
          <Carousel autoRotateMs={5000} onIndexChange={setActiveIndex} data-sentry-element="Carousel" data-sentry-source-file="ValueProps.tsx">
            {SLIDES.map(({
            src,
            caption,
            title
          }, i) => <YStack key={i} flex={1} justifyContent="space-between" paddingHorizontal="$sp2.5">
                <Display2 textAlign="center">{title}</Display2>
                <YStack>
                  {/* Shadow on outer; inner wrapper does the rounded clipping —
                    overflow:hidden clips box-shadow on some renderers. */}
                  <YStack {...shadow.medium} borderRadius={36} margin="$sp1.5">
                    <YStack borderRadius={36} overflow="hidden">
                      <ResponsiveImage src={src} alt="" objectFit="contain" width="100%" />
                    </YStack>
                  </YStack>
                  <Body1 color="$textSubtle" textAlign="center" marginHorizontal="$sp3">
                    {caption}
                  </Body1>
                </YStack>
              </YStack>)}
          </Carousel>
        </YStack>
      </OnboardingScreen.Content>
      <OnboardingScreen.Footer data-sentry-element="OnboardingScreen.Footer" data-sentry-source-file="ValueProps.tsx">
        <OnboardingScreen.PrimaryAction testID="value-props.get-started" variant="brand" onPress={() => onDone(Outcome.signUp())} data-sentry-element="OnboardingScreen.PrimaryAction" data-sentry-source-file="ValueProps.tsx">
          Get started
        </OnboardingScreen.PrimaryAction>
        <OnboardingScreen.TertiaryAction testID="value-props.log-in" onPress={() => {
        onDone(Outcome.logIn());
      }} data-sentry-element="OnboardingScreen.TertiaryAction" data-sentry-source-file="ValueProps.tsx">
          <Body1 color="$textSubtle" data-sentry-element="Body1" data-sentry-source-file="ValueProps.tsx">
            Already have an account?{" "}
            <TextSpan color="$textDefault" style={{
            textDecoration: "underline"
          }} bold data-sentry-element="TextSpan" data-sentry-source-file="ValueProps.tsx">
              Log in
            </TextSpan>
          </Body1>
        </OnboardingScreen.TertiaryAction>
      </OnboardingScreen.Footer>
    </OnboardingScreen>;
}